import React, { useRef } from "react";
import {
  Heading,
  Box,
  Textarea,
  Input,
  Text,
  Grid,
  GridItem,
  Hide,
  FormControl,
} from "@chakra-ui/react";
import Texts from "../animate/textAnimate";
import emailjs from "@emailjs/browser";
import { MdEmail } from "react-icons/md";
import { FaAddressCard } from "react-icons/fa";
import { BsTelephonePlusFill } from "react-icons/bs";

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_n4ys4b3",
        "template_04wzh47",
        form.current,
        "hsInv32YWaPjiMsSl"
      )
      .then(
        (result) => {
          console.log(result.text);
          alert("thanks for contacting me!");
        },
        (error) => {
          console.log(error.text);
        }
      );
  };
  return (
    <div id="contact">
      <Box border="1px solid orangered" m="auto" w="80%"></Box>
      <br />
      <Heading textAlign={"center"} color="orangered">
        <u>
          <Texts text="GET   IN   TOUCH" />
        </u>
      </Heading>
      <br />
      <Heading fontSize={"3xl"} textAlign="center">
        Contact Me
      </Heading>
      <br />
      <Box>
        <Grid
          h={["40px","180px","180px","180px"]}
          w={["50%","40%","40%",'30%']}
          m="auto"
          templateRows="repeat(2, 1fr)"
          templateColumns="repeat(3, 1fr)"
          gap={0}
          boxShadow="dark-lg"
          padding={["0.5rem", "1rem", "1.5rem", "2rem"]}
        >
          <GridItem color="orangered" alignItems={"center"}>
            <Box
              w="40%"
              m="auto"
              h="100%"
              borderRadius="50%"
              alignItems={"center"}
            >
              <BsTelephonePlusFill size={[20, 30, 40, 45]} color="orangered" />
            </Box>
          </GridItem>
          <GridItem
            color="orangered"
            alignItems={"center"}
            borderRight="1px solid orangered"
            borderLeft="1px solid orangered"
          >
            <Box
              w="40%"
              m="auto"
              h="100%"
              borderRadius="50%"
              alignItems={"center"}
            >
              <FaAddressCard size={[20, 30, 40, 45]} color="orangered" />
            </Box>
          </GridItem>
          <GridItem color="orangered" alignItems={"center"}>
            <Box
              w="40%"
              m="auto"
              h="100%"
              borderRadius="50%"
              alignItems={"center"}
            >
              <MdEmail size={[20, 30, 40, 45]} color="orangered" />
            </Box>
          </GridItem>
          <Hide below="sm">
          <GridItem>
            <Box w={["30%", "40%", "55%", "60%"]} m="auto">
              <Heading fontSize={["10px", "12px", "15px", "17px"]}>
                Phone
              </Heading>
              <Text fontSize={["6px", "8px", "11px", "12px"]}>7970609952</Text>
            </Box>
          </GridItem>
          <GridItem>
            <Box w={["30%", "40%", "55%", "60%"]} m="auto">
              <Heading fontSize={["10px", "12px", "15px", "17px"]}>
                Adress
              </Heading>
              <Text fontSize={["6px", "8px", "11px", "12px"]}>
                Ramgarh,Jharkhand
              </Text>
            </Box>
          </GridItem>

          <GridItem>
            <Box w={["30%", "40%", "55%", "60%"]} m="auto">
              <Heading fontSize={["10px", "12px", "15px", "17px"]}>
                E-Mail
              </Heading>
              <Text fontSize={["6px", "8px", "11px", "12px"]}>
                sinhamitali713@gmail.com
              </Text>
            </Box>
          </GridItem>
          </Hide>
        </Grid>
      </Box>
      <br />
      <Box>
        <Box w={["80%","60%","60%","60%"]} m="auto" h={["34rem","30rem","30rem","30rem"]} boxShadow={"2xl"}>
          <br />
          <Heading fontSize={"3xl"} textAlign="center">
            Any Service You Need
          </Heading>
          <br />

          <Box w="60%" m="auto" h="60%">
            {/* <FormControl  ref={form} onSubmit={sendEmail}> */}
            <Input
              isInvalid
              errorBorderColor="red.300"
              fontSize={"lg"}
              placeholder="write your name "
              h="20%"
              focusBorderColor="red.300"
              className="user"
              type="text"
              name="user_name"
            />
            <br />
            <br />
            <Input
              isInvalid
              errorBorderColor="red.300"
              placeholder="write your email"
              h="20%"
              fontSize={"lg"}
              focusBorderColor="red.300"
              className="user"
              type="email"
              name="user_email"
            />
            <br />
            <br />
            <Textarea
              placeholder="drop your message for me"
              h="40%"
              border="2px solid orangered"
              fontSize={"lg"}
              focusBorderColor="red.300"
              className="user"
              name="message"
            />
            <br />
            <br />
            <Input
              isInvalid
              errorBorderColor="red.300"
              focusBorderColor="red.300"
              value="send"
              className="button"
              type="submit"
              h="20%"
              fontSize={"2xl"}
              background="orangered"
              color="white"
              _hover={{
                background: "white",
                color: "orangered",
                border: "2px solid orangered",
                cursor: "pointer",
              }}
            />
            {/* </FormControl> */}
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default Contact;
